import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AppLayout from '../../layouts/app/AppLayout';
import './custom.scss';

import { translateThis } from '../../helpers/language.helper';
import AppIcons from '../../assets/images/icons';
import SVGIcons from '../../assets/images/icons/svgIcons';
import ApiCaller from '../../services/api/APICaller';
// import S3ImageViewerWithFallback from '../../components/awsS3ImageViewer/ImgViewerWithFallback';





const ProjectPage = () => {
    // custom home functions here
    const pageName = "Projects";
    const [dataArr, setDataArr] = useState([]);

    useEffect(()=> {
        getDataArr();
    },[])

    const getDataArr = ()=> {
        const apiCaller = new ApiCaller('projects/our-projects');
        apiCaller.getList().then(({data})=> setDataArr(data.result))
    }

    const projectList = [
        {
            icon: AppIcons.empoweringWomens,
            title: 'Empowering women',
            description: 'Her club By Dolly’s mission is to use practical methods such implementing machinery to help girls and women produce their own sanitary pad and manage their menstruation hygiene.',
            link: '/projects/empowering-women',
        },
        {
            icon: AppIcons.waterEnergy,
            title: 'Sustainable water & energy',
            description: 'The project aims to provide safe drinking water to empower mainly schools and hospitals. This water system is an off-the-grid generator that can produce pure water from water vapor.',
            link: '/projects/sustainable-water-energy-solution',
        },
        {
            icon: AppIcons.futureOfKids,
            title: 'Creating a bright future for kids',
            description: 'Our initiative is dedicated to empower education for communities worldwide. We provide individuals with access to quality education and essential resources.',
            link: '/coming-soon',
        },


    ];

    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper projects-main-wrapper f-wrp">
                <div className='main-container-wrp'>
                    <div className='project-grid-wrp f-wrp'>
                        <div className='row'>
                            <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                                <div className='project-img-grid f-wrp'>
                                    <div className='lft-grid-sec f-wrp'>
                                        <div className='each-grid-items f-wrp'>
                                            <span className='grid-img'><img src={AppIcons.projectImg1} alt='about us' /></span>
                                        </div>
                                        <div className='each-grid-items f-wrp'>
                                            <span className='grid-img'><img src={AppIcons.projectImg2} alt='about us' /></span>
                                        </div>
                                    </div>
                                    <div className='ryt-grid-sec f-wrp'>
                                        <div className='each-grid-items f-wrp'>
                                            <span className='grid-img'><img src={AppIcons.projectImg3} alt='about us' /></span>
                                        </div>
                                        <div className='each-grid-items f-wrp'>
                                            <span className='grid-img'><img src={AppIcons.waterBanner} alt='about us' /></span>
                                        </div>
                                        {/* <div className='each-grid-items f-wrp'>
                                            <Link className='grid-button'>
                                                <h3>{translateThis("3+")}</h3>
                                                <p>{translateThis("Projects")}</p>
                                            </Link>
                                        </div> */}
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-7 col-md-6 col-sm-12 col-xs-12">
                                <div className='project-con-grid f-wrp'>
                                    <div className='project-con-header f-wrp'>
                                        <h1>{translateThis("Transforming lives through")} <b>{translateThis("our projects")}</b></h1>
                                        <p>{translateThis('projectIntroText')}</p>
                                    </div>

                                    <div className='latest-project-list f-wrp'>
                                        <ul>
                                            {projectList.map((element, key) => (
                                                <li key={key}>
                                                    <div className='each-project-box'>
                                                        {/* <span className='project-img'><S3ImageViewerWithFallback fileKey={element?.image} /> </span> */}
                                                        <span className='project-img'><img src={element.icon} alt='article' /></span>
                                                        <div className='project-detail-box'>
                                                            <p><b>{element.title}</b></p>
                                                            <p>{element.description}</p>
                                                            {/* <p>{element.shortDescription}</p> */}
                                                            <div className='btn-sec-wrp f-wrp'>
                                                                <div className='btn-wrp'>
                                                                    <Link to={element.link ?? '/'} className='pln-btn'>{translateThis("Learn more")} <SVGIcons.LearnMoreArrow /></Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default ProjectPage;